
(function( ){

//------------------------------------------------------------------------------------------------------------------------------

	var HamburgerMenu = function( )
	{
		var _this = this , i ;

		//     -     -     -     -     -     -     -     -     -     -

		var html = document.documentElement ;
		var body = document.body ;

		var _root = document.getElementsByClassName( "js-hamburger-menu" )[0] ;

		if( !_root ){
			console.warn("規定のハンバーガーメニュー構造のDOMが見つかりません。");
			return ;
		}

		var bg_layer = _root.getElementsByClassName( "bg-layer" )[0] ;

		var btn_open = _root.getElementsByClassName( "btn-nav-open" )[0] ;
		var wrap_opened_nav = _root.getElementsByClassName( "wrap-opened" )[0] ;
		var btn_close = wrap_opened_nav.getElementsByClassName( "btn-nav-close" )[0] ;

		btn_open.style.opacity = 0 ;

		var _onOpenClose = function( evt )
		{
			switch( evt.currentTarget )
			{
				case btn_open :
					HamburgerMenu.open( ) ;
					break ;

				case bg_layer :
				case btn_close :
					HamburgerMenu.close( ) ;
					break ;
			}
		}

		btn_open.addEventListener( "click" , _onOpenClose ) ;
		btn_close.addEventListener( "click" , _onOpenClose ) ;
		bg_layer.addEventListener( "click" , _onOpenClose ) ;

		//

		var _onScroll = function( )
		{
			var scrollY = window.pageYOffset ;
			var windowHeight = html.offsetHeight ;

			if( btn_open.style.pointerEvents == "none" && windowHeight/2 < scrollY )
			{
				btn_open.style.display = "block" ;
				btn_open.style.pointerEvents = "auto" ;
				Tween.add( btn_open.style , { opacity:1 , time:0.15 , transition:"linear" } ) ;
			}
			else if( btn_open.style.pointerEvents == "auto" && windowHeight/2 >= scrollY )
			{
				btn_open.style.pointerEvents = "none" ;
				Tween.add( btn_open.style , { opacity:0 , time:0.15 , transition:"linear" } ,
					{ onComplete:function(){btn_open.style.display="none";} } ) ;
			}
		}

		btn_open.style.pointerEvents = "none" ;
		wrap_opened_nav.style.pointerEvents = "none" ;

		window.addEventListener( "scroll" , _onScroll ) ;

		//

		HamburgerMenu.open = function( )
		{
			body.style.overflow = "hidden" ;
			wrap_opened_nav.style.display = "block" ;
			wrap_opened_nav.scrollTop = 0 ;
			Tween.add( wrap_opened_nav.style , { opacity:1 , time:0.15 , transition:"linear" } ,
				{ onComplete:function(){wrap_opened_nav.style.pointerEvents="auto";} } ) ;
		}

		HamburgerMenu.close = function( )
		{
			body.style.overflow = "" ;
			wrap_opened_nav.style.pointerEvents = "none" ;
			Tween.add( wrap_opened_nav.style , { opacity:0 , time:0.15 , transition:"linear" } ,
				{ onComplete:function(){wrap_opened_nav.style.display="none";} } ) ;
		}
	}

//------------------------------------------------------------------------------------------------------------------------------

	// DOMの準備が完了したら、呼ぶ
	document.readyState === "complete"
		? setTimeout( HamburgerMenu , 1 )
		: document.addEventListener( "DOMContentLoaded", HamburgerMenu ) ;

} )( ) ;
